var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainDiv"},[_c('div',{staticClass:"content"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.news.title))]),_vm._v(" "),_c('div',{staticClass:"meta"},[_vm._v(_vm._s(_vm._f("formatDate")(_vm.news.time)))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.news.content)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed78c4e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/news/news.vue
// module id = null
// module chunks = 